import { apiPath, REACT_APP_CONTRACT_API_URL } from './apiPath';
import app from './appClient';
import commonClient from './commonClient';
import createApiInstance from './createApiInstance';

const contractAPI = createApiInstance(REACT_APP_CONTRACT_API_URL);

export const getEmpContracts = (reqPayload) => app.post(apiPath.employerContracts, reqPayload);
export const fetchContractDetailsAPI = (contractId) => contractAPI.get(apiPath.contractDetails + contractId);
export const getContracts = (reqPayload) => commonClient.post(REACT_APP_CONTRACT_API_URL + apiPath.getContracts, reqPayload);
export const getContractInvoiceStatus = (reqPayload) => commonClient.get(REACT_APP_CONTRACT_API_URL + apiPath.getContractInvoiceStatus, reqPayload);